"use strict";

var cov_11yqbgu2z0 = function () {
  var path = "C:\\Projects-UnfoldingWord\\scripture-resources-rcl\\src\\components\\index.js";
  var hash = "65a745f20b5c1cc57ce0e2c34224c7d3d6ed01b7";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "C:\\Projects-UnfoldingWord\\scripture-resources-rcl\\src\\components\\index.js",
    statementMap: {},
    fnMap: {},
    branchMap: {},
    s: {},
    f: {},
    b: {},
    _coverageSchema: "43e27e138ebf9cfc5966b082cf9a028302ed4184",
    hash: "65a745f20b5c1cc57ce0e2c34224c7d3d6ed01b7"
  };
  var coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  return coverage[path] = coverageData;
}();

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _book = require("./book");

Object.keys(_book).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _book[key];
    }
  });
});

var _chapters = require("./chapters");

Object.keys(_chapters).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _chapters[key];
    }
  });
});

var _verseObjects = require("./verse-objects");

Object.keys(_verseObjects).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _verseObjects[key];
    }
  });
});

var _verses = require("./verses");

Object.keys(_verses).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _verses[key];
    }
  });
});

var _parallelScripture = require("./parallel-scripture");

Object.keys(_parallelScripture).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _parallelScripture[key];
    }
  });
});

var _usfm = require("./usfm");

Object.keys(_usfm).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _usfm[key];
    }
  });
});

var _resources = require("./resources");

Object.keys(_resources).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _resources[key];
    }
  });
});

var _license = require("./license");

Object.keys(_license).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _license[key];
    }
  });
});

var _selections = require("./selections");

Object.keys(_selections).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _selections[key];
    }
  });
});